export default __webpack_public_path__ + "assets/6f7f2f7491bceed7c816f39e546118d0-logo_cafe_white.svg";